import React, { useState } from "react";
import "./AccountDeletionRequest.css"; // Import the CSS file

const AccountDeletionRequest = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const [confirmation, setConfirmation] = useState(false);

  const handleInputChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!email || !confirmation) {
      setError(true);
      setMessage('Please provide your email and confirm that you want to delete all your data.');
      return;
    }

    // Send the email request (you can integrate this with a backend service or mailto)
    const emailSubject = "Account Deletion Request";
    const emailBody = `User with email: ${email} has requested account deletion.`;

    window.location.href = `mailto:help.growtube.app@gmail.com?subject=${emailSubject}&body=${emailBody}`;

    // Show a confirmation message
    setError(false);
    setMessage("Your request has been sent. We will process it shortly.");
  };

  return (
    <div className="account-deletion-form-container">
      <h1 className="account-deletion-heading">Account Deletion Request</h1>
      <p className="account-deletion-description">
        If you would like to delete your account, please enter your email below
        and we will process your request.
      </p>

      <form className="account-deletion-form" onSubmit={handleSubmit}>
        <label className="account-deletion-label" htmlFor="email">
          Email Address:
        </label>
        <input
          className="account-deletion-input"
          type="email"
          id="email"
          value={email}
          onChange={handleInputChange}
          required
          placeholder="Enter your email"
        />

        <div>
          <label>
            <input
              type="checkbox"
              checked={confirmation}
              onChange={(e) => setConfirmation(e.target.checked)}
            />
            I confirm that I want to delete all my data.
          </label>
        </div>
        <button className="account-deletion-submit-button" type="submit">
          Request Deletion
        </button>
      </form>

      {message && (
        <p
          className={`account-deletion-message ${error ? "error" : "success"}`}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default AccountDeletionRequest;
